/* istanbul ignore file */
import templates from './templates';
import templateContainer from './templateContainer';

const reducers = {
  templates,
  templateContainer,
};

export default reducers;
